import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/staff-stickers'),
      component: SettingsWrapper,
      props: {
        headerTitle: 'STAFF_STICKERS.TITLE',
        icon: 'i-lucide-sticker',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'staff_stickers_settings_index',
          component: Index,
          meta: { permissions: ['administrator', 'staff_sticker_manage'] },
        },
      ],
    },
  ],
};
